/**
 * A skeleton block.
 *
 * `design/DESIGN-SYSTEM.md` §2, verbatim: "skeleton blocks in
 * `--mdx-line-soft`, radius matching the real element, `mdxPulse` opacity
 * 1 → .55 → 1 over 1.4s. **Never a bare centred spinner on a full page;
 * preserve the real layout so nothing jumps when content lands.**"
 *
 * Which is why this takes a height and a width rather than drawing a card of
 * its own: the loading state is the real layout with these in the slots, so the
 * page does not reflow when the data arrives.
 *
 * `mdxPulse` is defined once in `index.css`, where `prefers-reduced-motion`
 * already collapses `--mdx-dur-pulse` for everything.
 *
 * Story 4.1.
 */
export function Skeleton({
  className = '',
  style,
}: {
  className?: string
  /**
   * Story 6.1: a PERCENTAGE width, the way `SeatBar` takes one. The funnels
   * grid's four skeleton cards have different bar widths in the export so the
   * loading state does not read as a repeating pattern, and a proportion of a
   * grid column is not a design token — there is no pixel to put in
   * `design/tokens.css`. Anything with a unit belongs in a class.
   */
  style?: { width: `${number}%` }
}) {
  return (
    <span
      aria-hidden="true"
      className={['block animate-mdx-pulse rounded-mdx-control bg-mdx-line-soft', className]
        .filter(Boolean)
        .join(' ')}
      style={style}
    />
  )
}
